import {Component, OnDestroy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MfaService} from './mfa.service';
import {BsModalService} from 'ngx-bootstrap/modal';
import {Subscription} from 'rxjs';
import {IMFAItem} from './interface';
import {MfaModalComponent} from './mfa-modal/mfa-modal.component';

/**
 * Component to handle security questions from connections, which are being engaged on their update.
 * Component provides a service to put next question in queue, which will be processed in time.
 * This service will also notify subscriber with processed question.
 */
@Component({
  selector: 'app-mfa',
  standalone: true,
  imports: [CommonModule],
  template: '',
})
export class MfaComponent implements OnDestroy {
  subscriptions: Subscription[] = [];
  mfa: IMFAItem[] = [];

  constructor(
    private mfaService: MfaService,
    private modalService: BsModalService,
  ) {
    this.subscriptions.push(
      this.mfaService.requested.subscribe((data) => this.pushToQueue(data)),
    );
    this.subscriptions.push(
      this.mfaService.processed.subscribe(() => {
        this.mfa.shift();
        this.showNext();
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  /**
   * Adds mfa to mfa queue. In case if this is first mfa (no current mfa in queue), will show it immediately.
   * @param data
   */
  pushToQueue(data: IMFAItem) {
    if (!this.mfa.length) {
      this.mfa.push(data);
      this.showNext();
    } else {
      this.mfa.push(data);
    }
  }

  /**
   * Opens mfa modal
   * Queue shift will happen on processed event, because need to track a modal which is currently opened.
   */
  showNext() {
    if (!this.mfa.length) {
      // nothing to show at the moment
      return;
    }
    const data = this.mfa[0];
    this.modalService.show(MfaModalComponent, {
      keyboard: false,
      backdrop: true,
      ignoreBackdropClick: true,
      initialState: {
        data,
      },
    });
  }
}
